<template>
  <header
    class="c-header row"
    role="banner"
    :class="{ 'pt-0': $infobarDisabled }"
  >
    <div class="row">
      <div class="col-xs-12">
        <switchover-banner v-if="!$infobarDisabled" />
        <app-banner
          :trigger-modal="triggerModal"
          @close="triggerModal = false"
          v-if="!isCollaboration && !$appCtaDisabled"
        />
      </div>
    </div>
    <div class="col-xs-6 col-sm-3">
      <mft-logo></mft-logo>
    </div>
    <div class="col-xs-6 col-sm-9 ta-right va-center">
      <span>
        <site-search-bar class="u-hide-mobile" />
        <base-button @click="gotoItSupport" is-link class="u-hide-tablet"
          >IT Support</base-button
        >
        <base-button
          @click="gotoItStatus"
          is-link
          :class="statusClass"
          class="u-hide-mobile"
          >IT Status</base-button
        >


      </span>
      <div class="u-profile-holder">
        <profile-card
          mini
          showNotifications
          :notificationCount="unread.length"
          @focus="displayNotificationList"
          v-click-outside="hideNotificationList"
        />
        <dropdown-profile v-if="showNotificationList">
          <ul class="c-profile-menu">
            <li class="ta-right">
              <router-link
                :to="{ name: 'CurrentUserProfile' }"
                @click.native="onProfileClick"
                >Settings</router-link
              >
            </li>
            <li>
              <profile-card noBorder @click="onProfileClick" />
            </li>
            <li class="split-text">
              <span>Notifications</span>
              <span>
                <base-button
                  asLink
                  type="button"
                  @click="markAllRead"
                  v-if="unread.length > 0"
                  >Mark all as read</base-button
                >
                <span v-else>All read</span>
              </span>
            </li>

            <li class="p-0">
              <base-scroll-list inner>
                <notification-list v-if="notifications.length > 0">
                  <li v-for="item in notifications" :key="item.id" tabindex="0">
                    <notification-card v-bind="item" />
                  </li>
                </notification-list>
                <div v-else>
                  <p class="p-10 ta-left">
                    You currently have no new notifications
                  </p>
                </div>
              </base-scroll-list>
            </li>
            <li class="p-0">
              <base-button
                :primary="true"
                block
                square
                @click="gotoNotifications"
                v-if="notifications.length > 0"
                >See all Notifications</base-button
              >
            </li>
          </ul>
        </dropdown-profile>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ProfileCard, BaseScrollableList as BaseScrollList } from '@/components/Containers';
import ClickOutside from 'vue-click-outside';

const MftLogo = () => import('./MftLogo');
const ItSupport = () => import('@/components/ItSupport');
const DropdownProfile = () => import('@/components/DropdownProfile');
const NotificationCard = () => import('@/components/NotificationCard');
const NotificationList = () => import('@/components/UserNotificationList');
const SiteSearchBar = () => import('@/components/SiteSearchBar');
const SwitchoverBanner = () => import('@/components/SwitchoverBanner');
const AppBanner = () => import('@/components/AppBanner');
export default {
  name: 'app-header',

  components: {
    MftLogo,
    ProfileCard,
    ItSupport,
    DropdownProfile,
    NotificationCard,
    BaseScrollList,
    NotificationList,
    SiteSearchBar,
    SwitchoverBanner,
    AppBanner,
  },
  directives: {
    ClickOutside,
  },

  methods: {
    markAllRead() {
      this.$store.dispatch('userNotifications/markAllAsRead');
    },
    gotoNotifications() {
      this.$router.push({ name: 'NotificationsIndexPage' });
      this.showNotificationList = false;
    },
    gotoItSupport() {
      this.$router.push('/content/corporate-services/group-informatics/it-support');
    },
    gotoItStatus() {
      this.$router.push({ name: 'SystemStatus' });
    },
    onProfileClick() {
      this.showNotificationList = !this.showNotificationList;
      // at this point, mark all notifications as read?
      // this.$store.dispatch("notifications/readAllNotifications");
    },
    displayNotificationList() {
      this.showNotificationList = true;
    },
    hideNotificationList() {
      this.showNotificationList = false;
    },
    toggleNotificationList($event) {
      if (!this.showNotificationList) {
        this.showNotificationList = true;
        return;
      }
      this.showNotificationList = false;
    },
    gotoProfile() {
      this.showNotificationList = false;
      this.$router.push({ name: 'CurrentUserProfile' });
    },
    setTriggerModal() {
      this.triggerModal = true;
    },
  },
  props: {
    supportModalOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('userNotifications', ['notifications']),
    ...mapGetters('userNotifications', ['unread']),
    ...mapGetters('systems', ['navigationSystems']),

    isCollaboration() {
      return this.$route.name && this.$route.name.toLowerCase().includes('collab');
    },

    statusClass() {
      if (this.navigationSystems) {
        const red = this.navigationSystems.filter(system => system.value === 0);

        if (red.length > 0) {
          return 'status--error';
        }

        const amber = this.navigationSystems.filter(system => system.value === 2);

        if (amber.length > 0) {
          return 'status--warning';
        }
        return 'status--normal';
      }
    },
  },
  watch: {
    showNotificationList(newValue, oldValue) {
      if (newValue) {
        document.querySelector('body').classList.add('noscroll');
      } else if (document.querySelector('body.noscroll')) {
        document.querySelector('body.noscroll').classList.remove('noscroll');
      }
    },
  },
  data() {
    return {
      showNotificationList: false,
      triggerModal: false,
    };
  },
  created() {
    this.$store.dispatch('userNotifications/list');
  },
};
</script>

<style lang="scss">
.c-header {
  background: $colour-nhs-white;
  height: 80px;
  padding: 1em;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  border-bottom: 1px solid $colour-nhs-pale-grey;

  @media screen and (min-width: 1024px) {
    padding-top: calc(1em + 40px);
    height: 140px;
    align-items: center;

    &.pt-0 {
      padding-top: 1em;
    }
  }

  .u-profile-holder {
    display: inline-block;
    position: relative;
    @media screen and (min-width: 768px) {
      top:-5px;
    }
    @media screen and (min-width: 1151px) {
      top:0;
    }
  }

  .split-text {
    display: flex;
    justify-content: space-between;
  }
}

.c-button.status--warning {
  background: #e3793b;
  color: #2f2f2f;
}

.c-button.status--error {
  background: #da291c;
  color: white;
}
</style>
